<div><div id="main-public"><router-view class="uk-container-large uk-margin-auto uk-padding"></router-view></div></div>